<template>
  <div>
    <div
      v-if="loading"
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 300px;
      "
    >
      <a-spin tip="Loading order details..." />
    </div>
    <div v-else style="margin: 32px auto; max-width: 1100px">
      <h2 style="font-size: 22px; font-weight: 700; margin-bottom: 24px">
        Fulfill Sales Order – {{ orderSummary.id }}
      </h2>

      <!-- Order Summary -->
      <a-card style="margin-bottom: 24px">
        <a-row gutter="24">
          <a-col :span="8">
            <div><b>Sales Order ID</b><br />{{ orderSummary.id }}</div>
          </a-col>
          <a-col :span="8">
            <div><b>Order Date</b><br />{{ orderSummary.orderDate }}</div>
          </a-col>
          <a-col :span="8">
            <div><b>Seller</b><br />{{ orderSummary.seller }}</div>
          </a-col>
          <a-col :span="8">
            <div style="margin-top: 16px">
              <b>Buyer</b><br />{{ orderSummary.buyer }}
            </div>
          </a-col>
          <a-col :span="8">
            <div style="margin-top: 16px">
              <b>Fulfillment Warehouse</b><br />{{ orderSummary.warehouse }}
            </div>
          </a-col>
          <a-col :span="8">
            <div style="margin-top: 16px">
              <b>Status</b><br />
              <StatusTag :status="orderSummary.status" />
            </div>
          </a-col>
        </a-row>
        <a-button
          type="link"
          style="margin-top: 16px; padding: 0; color: #059669"
          @click="goToOrderDetails"
        >
          <i
            class="fa fa-external-link-alt"
            style="color: #059669; margin-right: 8px"
          ></i>
          View Sales Order Details
        </a-button>
      </a-card>

      <!-- Product Fulfillment Table -->
      <a-card style="margin-bottom: 24px">
        <h3 style="font-weight: 600; margin-bottom: 16px">
          Product Fulfillment
        </h3>
        <a-table
          :columns="productColumns"
          :data-source="products"
          :pagination="false"
          :row-key="(record, index) => index"
          bordered
        >
          <template slot="pickedQty" slot-scope="text, record">
            <a-input-number
              v-model="record.pickedQty"
              :min="0"
              :max="record.orderedQty"
              placeholder="Enter Quantity"
              style="widthh: 150px"
              @change="validatePickedQty(record)"
            />
            <!-- <a-button
              type="link"
              @click="pickFromBatch(record, index)"
              style="color: #26a246"
              >Pick From Batch</a-button
            > -->
          </template>
          <template slot="action" slot-scope="record">
            <StatusTag
              :status="
                record.pickedQty === record.orderedQty ? 'Picked' : 'Not Picked'
              "
            />
          </template>
          <!-- <template #action="{ index }">
            <a-button
              type="primary"
              style="margin-left: 8px; background-color: #26a246; border: none"
              @click="markAsPicked(products[index])"
            >
              <i class="fa fa-check-circle" style="margin-right: 8px"></i> Mark as
              Picked
            </a-button> 
          </template> -->
        </a-table>
      </a-card>

      <!-- Internal Notes & Delivery Note -->
      <a-card style="margin-bottom: 24px">
        <h3 style="font-weight: 600; margin-bottom: 8px">Internal Notes</h3>
        <a-textarea
          v-model="internalNotes"
          placeholder="Add any internal notes about this fulfillment..."
          rows="3"
        />
        <div style="margin-top: 12px; color: #2563eb; font-size: 13px">
          <i class="fa fa-info-circle"></i> Delivery Note will be auto-generated
          upon completion
        </div>
      </a-card>

      <!-- Action Buttons -->
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <a-button @click="$router.back()">Cancel</a-button>
        <a-button
          type="primary"
          @click="completeFulfillment"
          :loading="completing"
          :disabled="!allMarkedAsPicked"
          icon="check"
        >
          Complete Fulfillment
        </a-button>
      </div>

      <!-- Batch Picker Drawer/Side Sheet -->
      <a-drawer
        :visible="batchDrawerVisible"
        :width="700"
        :title="`Select Batch for ${
          selectedProduct ? selectedProduct.name : ''
        }`"
        @close="batchDrawerVisible = false"
        placement="right"
      >
        <!-- Placeholder for batch selection UI -->
        <div v-if="selectedProduct">
          <a-alert
            v-if="batchPickAlert"
            :message="batchPickAlert"
            type="error"
            show-icon
            style="margin-bottom: 16px"
          >
            <!-- <template slot="icon">
              <i class="fa fa-exclamation-triangle" style="color: #FF0000; font-size: 16px;"></i>
            </template> -->
          </a-alert>
          <!-- TODO: Replace with actual batch data and UI -->
          <p>Ordered: {{ selectedProduct.orderedQty }} doses</p>
          <a-table
            :columns="batchColumns"
            :data-source="batchList"
            :pagination="false"
            row-key="batchId"
            bordered
          >
            <template slot="picked" slot-scope="text, record">
              <a-input-number
                v-model="record.picked"
                :min="0"
                :max="record.availableQty"
                :step="1"
                style="width: 80px"
                @change="validateBatchPickedQty(record)"
              />
            </template>
            <template #status>
              <span
                style="
                  color: #26a246;
                  border: 1px solid #26a246;
                  border-radius: 12px;
                  padding: 2px 12px;
                  font-size: 13px;
                  background: #e6f9ec;
                "
                >Available</span
              >
            </template>
          </a-table>
          <!-- Fulfillment Summary (placeholder) -->
          <div style="margin-top: 24px">
            <b>Fulfillment Summary</b>
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 12px;
              "
            >
              <a-card
                bordered="true"
                style="border-radius: 16px; min-width: 200px"
              >
                <div style="color: #222; font-size: 13px">Total Ordered</div>
                <div style="font-size: 22px; font-weight: 700">
                  {{ selectedProduct.orderedQty }}
                </div>
              </a-card>
              <a-card style="border-radius: 16px; min-width: 200px">
                <div style="color: #222; font-size: 13px">Total Picked</div>
                <div style="font-size: 22px; font-weight: 700; color: #2563eb">
                  {{ totalBatchPicked }}
                </div>
              </a-card>
              <a-card style="border-radius: 16px; min-width: 200px">
                <div style="color: #222; font-size: 13px">
                  Remaining to Pick
                </div>
                <div style="font-size: 22px; font-weight: 700; color: #f97316">
                  {{ Math.abs(selectedProduct.orderedQty - totalBatchPicked) }}
                </div>
              </a-card>
            </div>
          </div>
        </div>
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 16px;
            margin-top: 190px;
            padding: 16px 24px 0 24px;
            border-top: 1px solid #f0f0f0;
            background: #fff;
          "
        >
          <span style="font-weight: 500; color: #222"
            >Total Selected: {{ totalBatchPicked }} Units</span
          >
          <div style="display: flex; align-items: center; gap: 16px">
            <a-button @click="batchDrawerVisible = false">Cancel</a-button>
            <a-button
              type="primary"
              style="background-color: #26a246; border: none"
              @click="saveBatchSelection"
              >Save Selection</a-button
            >
          </div>
        </div>
      </a-drawer>
    </div>
  </div>
</template>

<script>
import sellersService from "../../../api/sellers.service";
import StatusTag from "../../shared-components/StatusTag.vue";
import { formatDate, orderStatus } from "../../../utils";

export default {
  name: "FulfillOrder",
  components: {
    StatusTag,
  },
  props: {
    orderId: {
      type: String,
      required: true,
    },
    userId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      orderSummary: {
        id: "",
        orderDate: "",
        seller: "",
        buyer: "",
        warehouse: "",
        status: "",
      },
      orderNumber: "",
      products: [],
      internalNotes: "",
      loading: true,
      completing: false,
      productColumns: [
        {
          title: "Product Name",
          dataIndex: "name",
          key: "name",
        },
        { title: "Ordered Qty", dataIndex: "orderedQty", key: "orderedQty" },
        {
          title: "Picked Qty",
          key: "pickedQty",
          scopedSlots: { customRender: "pickedQty" },
        },
        {
          title: "Action",
          key: "action",
          scopedSlots: { customRender: "action" },
        },
      ],
      batchDrawerVisible: false,
      selectedProduct: null,
      selectedProductIndex: null,
      batchList: [], // Example: [{ batchId, availableQty, expiryDate, shelfLife, picked }]
      batchColumns: [
        { title: "Batch ID", dataIndex: "batchId", key: "batchId" },
        {
          title: "Available Qty",
          dataIndex: "availableQty",
          key: "availableQty",
          customRender: (text) => `${text} Units`,
        },
        { title: "Expiry Date", dataIndex: "expiryDate", key: "expiryDate" },
        {
          title: "Shelf Life",
          dataIndex: "shelfLife",
          key: "shelfLife",
          customRender: (text) => `${text} Days`,
        },
        {
          title: "Picked",
          key: "picked",
          scopedSlots: { customRender: "picked" },
        },
        {
          title: "Status",
          key: "status",
          scopedSlots: { customRender: "status" },
        },
      ],
      batchPickAlert: "",
    };
  },
  created() {
    this.fetchOrderDetails();
  },
  methods: {
    async fetchOrderDetails() {
      this.loading = true;
      const response = await sellersService.getSellerOrderDetails(this.orderId);
      console.log(response);
      if (response.status === 200 && response.data && response.data.data) {
        const data = response.data.data;
        if(data.status === 3) {
          this.$router.push({ name: 'seller-order-details', params: { userId: this.userId, orderId: this.orderId } })
          return
        }


        // Fetch seller details using sellerId
        let sellerName = "";
        if (data.sellerId) {
          try {
            const sellerResponse = await sellersService.getSeller(
              data.sellerId
            );
            if (
              sellerResponse.status === 200 &&
              sellerResponse.data &&
              sellerResponse.data.data
            ) {
              const sellerData = sellerResponse.data.data;
              sellerName =
                sellerData.businessDetails?.businessName ||
                sellerData.accountDetails?.tradingName ||
                "Unknown Seller";
              this.loading = false;
            } else {
              this.$message.error("Failed to fetch seller details");
            }
          } catch (error) {
            console.error("Error fetching seller details:", error);
            sellerName = "Unknown Seller";
          }
        }

        this.orderSummary = {
          id: data.id,
          orderDate: formatDate(data.createdAt),
          seller: sellerName,
          buyer: data.invoiceResponse?.customerBusinessName || "N/A",
          warehouse: data.warehouseName || "N/A",
          status: orderStatus[data.status] || "N/A",
        };
        this.orderNumber = data.orderNumber || data.id;
        this.products = (data.productDetails || []).map((item) => {
          const name = item.productName || item.name || "Unnamed Product";
          const product = {
            name,
            orderedQty: item.quantity,
            pickedQty: 0, // Default, update as needed
          };
          if (item.sku) product.sku = item.sku;
          return product;
        });
      } else {
        this.$message.error("Failed to fetch order details");
      }
    },
    goToOrderDetails() {
      // Navigate to the order details page
      this.$router.push({
        name: "seller-order-details",
        params: { userId: this.userId, orderId: this.orderId },
      });
    },
    pickFromBatch(record, index) {
      // Use the product from the products array to ensure reactivity
      this.selectedProduct = this.products[index];
      this.selectedProductIndex = index;
      // TODO: Fetch actual batch data for the product
      this.batchList = [
        {
          batchId: "ND-003",
          availableQty: 8,
          expiryDate: "30-06-2026",
          shelfLife: 200,
          picked: 0,
        },
        {
          batchId: "ND-004",
          availableQty: 20,
          expiryDate: "15-09-2026",
          shelfLife: 145,
          picked: 0,
        },
      ];
      this.batchDrawerVisible = true;
    },
    saveBatchSelection() {
      // Sum picked from all batches
      const totalPicked = this.batchList.reduce(
        (sum, b) => sum + (b.picked || 0),
        0
      );
      // Update the pickedQty for the selected product
      if (this.selectedProductIndex !== null) {
        this.products[this.selectedProductIndex].pickedQty = totalPicked;
      }
      this.batchDrawerVisible = false;
    },
    markAsPicked(record) {
      // TODO: Implement mark as picked logic
      this.$message.success(`${record.name} marked as picked!`);
    },
    async completeFulfillment() {
      try {
        this.completing = true;
        const response = await sellersService.completeOrderFulfillment(
          this.orderId
        );

        if (response.status === 200) {
          this.orderSummary.status = "Received";
          this.$message.success(
            "Fulfillment completed and order marked as Completed!"
          );
          this.$router.push(`/sellers/${this.userId}?tab=7`);
        } else {
          this.$message.error("Failed to complete fulfillment.");
        }
      } catch (error) {
        this.$message.error("Failed to complete fulfillment.");
        console.error("Error completing fulfillment:", error);
      } finally {
        this.completing = false;
      }
    },
    validatePickedQty(record) {
      if (record.pickedQty > record.orderedQty) {
        this.$message.error(
          "Picked quantity cannot be more than ordered quantity!"
        );
        // record.pickedQty = record.orderedQty;
      }
    },
    validateBatchPickedQty(record) {
      if (record.picked > record.availableQty) {
        this.batchPickAlert =
          "Sorry, you can't exceed the above number for quantity picked.";
        record.picked = record.availableQty;
      } else {
        this.batchPickAlert = "";
      }
    },
  },
  computed: {
    totalBatchPicked() {
      return this.batchList.reduce((sum, b) => sum + (b.picked || 0), 0);
    },
    allMarkedAsPicked() {
      return this.products.every(
        (product) =>
          product.orderedQty > 0 && product.pickedQty === product.orderedQty
      );
    },
  },
};
</script>

<style scoped></style>
